/**
 * Custom instructions (ENG-3357) — the Swivl-staff free-text escape hatch that
 * lands in the bot's system prompt. One bounded, sanitized value per scope.
 *
 * The same normalization runs everywhere the value is touched: Studio
 * (validation + counter), the Policy Assistant (its drafts obey the cap) and
 * the bot's prompt builder (defensive — a row written by any other path is
 * still bounded before it reaches the model).
 */
export const CUSTOM_INSTRUCTIONS_MAX_CHARS = 1500;

/**
 * Normalize a stored value for the prompt: trim, drop `{{ }}` (the prompt
 * builder's variable syntax — never let an operator string expand a variable),
 * collapse runs of blank lines, and cut at the cap on a word boundary.
 */
export function sanitizeCustomInstructions(raw: string | null | undefined): string {
  if (typeof raw !== "string") return "";
  let text = raw
    .replace(/\{\{|\}\}/g, "")
    .replace(/\r\n?/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  if (text.length > CUSTOM_INSTRUCTIONS_MAX_CHARS) {
    const cut = text.slice(0, CUSTOM_INSTRUCTIONS_MAX_CHARS);
    const lastBreak = Math.max(cut.lastIndexOf(" "), cut.lastIndexOf("\n"));
    text = (lastBreak > CUSTOM_INSTRUCTIONS_MAX_CHARS * 0.8 ? cut.slice(0, lastBreak) : cut).trim();
  }
  return text;
}
